<template>
    <div class="row">
        <div
            class="col-sm-3 text-center"
            v-show="records && records.length > 0"
            v-for="record in records"
            :key="record.id"
        >
            <div class="d-flex justify-content-center">
                <img :src="certificateImageUrl" width="90px"/>
            </div>
            <br>
            <div class="d-flex justify-content-center">
                <b class="text-capitalize">
                    {{ record.request_type }}
                </b>
            </div>
            <div class="d-flex justify-content-center">
                <small class="text-danger">
                    Expires on
                    {{ record.expiry_date | getDateFormat }}
                </small>
            </div>

            <div class="d-flex justify-content-center">
                <form 
                    :action="getRootUrl+'/print-hospital-letter'"
                    method="POST" 
                    target="_blank"
                    v-if="record && record.letter"
                >
                    <input type="hidden" name="id" :value="record.id" />
                    <input type="hidden" name="authorization_token" :value="getAuthorizationToken" />
                    <input type="hidden" name="option" value="user" />
                    <input type="hidden" name="hospital_id" :value="hospital.id" />
                    <input type="hidden" name="date" :value="record.approved_date" />
                    <input type="hidden" name="ref_no" :value="record.letter.ref_no" />
                    <input type="hidden" name="last_quota" :value="record.letter.last_quota" />
                    <input type="hidden" name="plenary" :value="record.letter.plenary" />
                    <input type="hidden" name="plenary_date" :value="record.letter.plenary_date" />
                    <input type="hidden" name="plenary_venue" :value="record.letter.plenary_venue" />
                    <input type="hidden" name="visit_date" :value="record.letter.visit_date" />
                    <input type="hidden" name="quota" :value="record.letter.quota" />

                    <base-button
                        size="sm"
                        type="success"
                        nativeType="submit"
                    >
                        <i class="fa fa-print"></i>
                        Open Document
                    </base-button>

                </form>
            </div>
            <br>
        </div>

    </div>

</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'LetterData',
        props: ['records'],
        filters: {
            getDateFormat(value) {
                return moment(value).format('Do MMM, YYYY');
            }
        },
        computed: {
            ...mapGetters(['certificateImageUrl', 'getRootUrl', 'hospital', 'getAuthorizationToken'])
        }
    }
</script>

<style scoped>
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>
